import {getItemName, getPayName} from "../../../shared/utils/basic";

const CAPSULE_GRADE = ['일반', '고급', '희귀'];

export const getGachaLogColumns = (krTextData, currentUser) => {
    return [
        {
            title: '뽑기 타입',
            dataIndex: 'logString',
            render: (logString, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                return getPayName(krTextData[currentUser.target], record.parsedLogData.gachaType)
            },
            filterMultiple: false,
            filters: [
                {text: '일반', value: 'GachaCommon'},
                {text: '배지', value: 'GachaBadge'},
                {text: '이벤트 뽑기', value: 'GachaEvent'},
            ],
            onFilter: (value, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(record.logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                return record.parsedLogData.gachaType === value;
            },
        },
        {
            title: '재화 타입',
            dataIndex: 'logString',
            render: (logString, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                return getPayName(krTextData[currentUser.target], record.parsedLogData.payType)
            }
        },
        {
            title: '재화 ID',
            dataIndex: 'logString',
            render: (logString, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                return record.parsedLogData.payType
            },
        },
        {
            title: '지불 금액',
            dataIndex: 'logString',
            render: (logString, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                return record.parsedLogData.payCost;
            }
        },
        {
            title: '획득 아이템',
            dataIndex: 'logString',
            render: (logString, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                if (Array.isArray(record.parsedLogData.itemId)) {
                    const itemList = record.parsedLogData.itemId.map((item, index) => {
                        const grade = record.parsedLogData.capsuleGrade?.[index];
                        const gradeText = grade === undefined ? '' : `[${CAPSULE_GRADE[grade] ?? grade}] `;
                        return gradeText + getItemName(krTextData[currentUser.target], item, record.parsedLogData.itemType[index]) + `(${item}) ${record.parsedLogData.itemQuantity[index]}개`
                    });
                    return itemList.join(', ');
                } else {
                    return getItemName(krTextData[currentUser.target], record.parsedLogData.itemId, record.parsedLogData.itemType);
                }
            },
            width: '50%'
        },
        {
            title: '획득 마일리지',
            dataIndex: 'logString',
            render: (logString, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                return record.parsedLogData.mileageGain;
            }
        },
        {
            title: '누적 마일리지',
            dataIndex: 'logString',
            render: (logString, record) => {
                if (!record.parsedLogData) {
                    try {
                        record.parsedLogData = JSON.parse(logString);
                    } catch (error) {
                        console.error('logString 파싱 오류:', error);
                        record.parsedLogData = {};
                    }
                }
                return record.parsedLogData.mileageTotal;
            }
        },
    ];
}